// node-modules
import LazyLoad from 'vanilla-lazyload';
import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import { SELECTORS } from '@/scripts/constants';
import { transitionDuration } from '@/scripts/animation/animation-selectors';
import { createEvent } from '@/scripts/utils';
import clickOutside from 'click-outside';
import { photoCounter } from '../../scripts/_states';

// assets
import './Dropdown.scss';


const defaults = {
  element: null,
  triggerElement: '[data-role*=dropdown-title]',
  innerList: '[data-role*="dropdown-inner-list"]',
  innerListItem: '[data-role*="dropdown-inner-item"]',
  activeClass: SELECTORS.active,
  duration: transitionDuration,
};


export default class Dropdown {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.element = options.element;
    this.triggerElement = this.element.querySelector(options.triggerElement);
    this.innerList = this.element.querySelector(options.innerList);
    this.innerListItems = Array.from(this.element.querySelectorAll(options.innerListItem));
    this.duration = options.duration;
    this.durationStagger = options.duration * 0.8;
    this.activeClass = options.activeClass;
    this.activeStatus = false;
    this.animated = false;

    this.unbindClickOutside = null;
    this.toggleDropdown = this.toggleDropdown.bind(this);

    this.toggleEndEvent = 'hevens-dropdown:toggle-end';
    this.init();
  }

  toggleDropdown() {
    if (this.animated) return;
    this.animated = true;
    const tl = new TimelineMax({
      onComplete: () => {
        this.activeStatus = !this.activeStatus;
        this.animated = false;
        this.element.dispatchEvent(createEvent(this.toggleEndEvent));
        window.dispatchEvent(createEvent('resize'));
      },
    });
    if (this.activeStatus) {
      this.element.classList.remove(this.activeClass);
      tl
        .to(this.innerList, this.duration, { height: 0 })
        .staggerTo(this.innerListItems, this.durationStagger, { opacity: 0, y: 20 }, '.05', 0);
    } else {
      this.element.classList.add(this.activeClass);
      tl
        .set(this.innerList, { height: 'auto' })
        .set(this.innerListItems, { opacity: 1, y: 30 })
        .from(this.innerList, this.duration, { height: 0 })
        .staggerTo(this.innerListItems, this.durationStagger, { opacity: 1, y: 0, clearProps: 'all' }, '.05', 0);
    }
  }

  destroy() {
    this.unbindClickOutside();
  }

  init() {
    this.triggerElement.addEventListener('click', this.toggleDropdown.bind(this));
    this.unbindClickOutside = clickOutside(this.element, () => {
      if (this.activeStatus) {
        this.element.removeEventListener(this.toggleEndEvent, this.toggleDropdown, { once: true });
        this.toggleDropdown();
      } else if (this.animated) {
        this.element.addEventListener(this.toggleEndEvent, this.toggleDropdown, { once: true });
      }
    });
    TweenMax.set(this.innerList, { height: 0 });
    const dropdownLists = document.querySelectorAll('[data-dropdown-list]');
    const filters = document.querySelectorAll('[data-role*=filters-container]');
    const coverBg = document.querySelector('[data-cover-image]');
    const albums = document.querySelectorAll('[data-dropdown-filter]');

    dropdownLists.forEach((dropdownList) => {
      const dropdownTitle = dropdownList.querySelector('[data-dropdown-title]');
      const filterGridPhotos = document.querySelectorAll('[data-filter-tags]');
      const signatures = document.querySelectorAll('[data-cover-signature-type]');
      dropdownList.addEventListener('click', (e) => {
        if (e.target.dataset.dropdownItem === 'hide-on-click') {
          const title = e.target.querySelector('[data-dropdown-title-item]');
          const activeEyebrow = document.querySelector('[data-active-eyebrow]');
          if (title) {
            const coverTitle = document.querySelector('[data-paste-title] h1');
            if (coverTitle) {
              coverTitle.textContent = title.textContent;
            }
          }
          if (activeEyebrow) {
            const eyebrow = activeEyebrow.querySelector('h6');
            eyebrow.textContent = activeEyebrow.dataset.hiddenEyebrow;
          }

          const span = e.target.querySelector('span');
          dropdownTitle.textContent = span.textContent;
          const activeSignature = [...signatures].find(signature => signature.dataset.coverSignatureType === 'photo');
          if (activeSignature) {
            activeSignature.classList.remove('hide');
          } else {
            signatures.forEach((signature) => {
              signature.classList.add('hide');
            });
          }
          const activeGridPhotos = [...filterGridPhotos].find(filterGridPhoto => filterGridPhoto.dataset.filterTags === e.target.dataset.filter);
          if (activeGridPhotos) {
            const imgs = activeGridPhotos.querySelectorAll('img');
            photoCounter.count = imgs.length;
            imgs.forEach(img => LazyLoad.load(img, {}));
          }

          const activeAlbum = [...albums].find(album => album.dataset.filter === e.target.dataset.filter);
          coverBg.src = activeAlbum.dataset.imageSrc;

          const photoCount = document.querySelector('[data-cover-count-photo]');
          if (photoCount) {
            photoCount.textContent = photoCounter.count;
          }
        }
      });
    });

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        dropdownLists.forEach((dropdownList) => {
          const dropdownTitle = dropdownList.querySelector('[data-dropdown-title]');
          if (dropdownTitle.dataset.dropdownTitle) {
            dropdownTitle.textContent = dropdownTitle.dataset.dropdownTitle;
          }
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./components/Dropdown/Dropdown.js